import {
  EntityFieldAndType,
  EntityFieldsAndIndicatorQuery,
  EntityFieldsAndIndicatorQueryVariables,
  EntityInterface,
} from '__generated__';
import { gql } from '@apollo/client';

import { useQuery } from 'shared/hooks';

export const ENTITY_FIELDS_AND_INDICATOR_QUERY = gql`
  query EntityFieldsAndIndicator($entityId: ID!) {
    entityFieldsWithTypes {
      field
      type
    }
    entity(id: $entityId) {
      id
      entityType
      reputation
      reputationSources
    }
  }
`;

export type EntityTypeFieldsAndIndicator = {
  entityTypeFields?: EntityFieldAndType[];
  entityIndicatorData?: Pick<
    EntityInterface,
    'id' | 'entityType' | 'reputation' | 'reputationSources'
  >;
};

export const useEntityFieldsAndIndicator = (entityId?: string) => {
  const { data, loading } = useQuery<
    EntityFieldsAndIndicatorQuery,
    EntityFieldsAndIndicatorQueryVariables
  >(ENTITY_FIELDS_AND_INDICATOR_QUERY, {
    variables: { entityId: entityId ?? '' },
    skip: !entityId,
    notifyErrors: false,
    errorPolicy: 'none',
  });

  // Filter out the fields that do not match entityType
  const entityTypeFields = data?.entityFieldsWithTypes.filter(
    (field) => field.type === data?.entity?.entityType
  );

  return {
    entityTypeFieldsAndIndicator: {
      entityTypeFields,
      entityIndicatorData: data?.entity,
    },
    loading,
  };
};
